// @flow

import { gql } from "@apollo/client";
import { graphql } from '@apollo/client/react/hoc';

const markOrderAsStockStagedByInventoryOrderCartonIdentifier: any = graphql(
  gql`
    mutation($cartonIdentifier: String!) {
      markOrderAsStockStagedByInventoryOrderCartonIdentifier(cartonIdentifier: $cartonIdentifier) {
        errors {
          cartonIdentifier
        }
        order {
          id
          isStockStaged
        }
        succeeded
      }
    }
  `,
  {
    name: "markOrderAsStockStagedByInventoryOrderCartonIdentifier"
  }
);

export default markOrderAsStockStagedByInventoryOrderCartonIdentifier;
